<template>
    <fragment>
        <div class="modal-title">
            Manage Subscription
            <i class="modal-close-button" @click="$emit('close')"></i>
        </div>
        <div class="modal-body">
            <div class="title-sub-sm ">
                Your Plan
            </div>
            <div class="title-md">
                {{subscriptionDetails.nickname}}
            </div>
            <div class="sep-8"></div>
            <div>
                Your {{subscriptionDetails.nickname}} subscription will renew on {{subscriptionDetails.renewal_date | moment("YYYY-MM-DD") }}.
            </div>
            <div class="sep-16"></div>
            <div class="columns">
                <div class="column">
                    <div class="button is-danger" @click="confirmCancel()">
                        Cancel Subscription
                    </div>
                </div>
                <div class="column" style="text-align: right">
                    <div @click="goToUpgrade()" class="button is-primary">
                        Upgrade
                    </div>
                </div>
            </div>
        </div>
    </fragment>
</template>

<script>
    import {PaymentAPI} from "../../../apis/PaymentAPI";
    import {config} from "@/config/config";


    export default {
        name: "ManageSubscriptionModal",
        data() {
            return {
            }
        },
        methods: {
            confirmCancel() {
                this.$buefy.dialog.confirm({
                    title: 'Subscription',
                    message: 'Are you sure you want to <b>cancel</b> your subscription?',
                    confirmText: 'Yes',
                    type: 'is-danger',
                    hasIcon: true,
                    onConfirm: async () =>{
                        this.$emit('close');
                        await this.$store.commit('account/loading');
                        let resp = await PaymentAPI.cancelSubscription();
                        await this.$store.dispatch('account/updateSubscriptionDetails');
                        if(resp.success !== true){
                            this.$buefy.dialog.alert('Opps..! Something wrong happened please try again later.')
                        }
                        else {
                          SFAnalytics.track('Subscription Cancelled', {
                            plan_name: this.subscriptionDetails.nickname,
                            subscription_end_date: new Date()
                          })
                        }
                        await this.$store.commit('account/loaded');
                    }
                })
            },
            goToUpgrade(){
                this.$emit('close');
                let planUrl = config('HOMEPAGE') + 'plans-pricing';
                window.location.href = planUrl;
                // this.$router.push({name: 'plans',});
            }
        },
        computed: {
            subscriptionDetails(){
                return this.$store.state.account.subscriptionDetails;
            }
        }
    }
</script>

<style scoped>

</style>
